import { render, staticRenderFns } from "./TheButton.vue?vue&type=template&id=22e05dfc&scoped=true&lang=pug&"
import script from "./TheButton.vue?vue&type=script&lang=ts&"
export * from "./TheButton.vue?vue&type=script&lang=ts&"
import style0 from "./TheButton.vue?vue&type=style&index=0&id=22e05dfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e05dfc",
  null
  
)

export default component.exports